import type { MailboxInfo } from 'owa-client-types';
import { isAccountFeatureEnabled } from 'owa-feature-flags';
import { isFrontierPrivateTAPUser } from './isFrontierPrivateTAPUser';
import { isFrontierPublicUser } from './isFrontierPublicUser';

// Is draft assistant enabled with frontier branding
export function isDraftAssistantFrontierEnabled(mailboxInfo: MailboxInfo): boolean {
    return (
        (isAccountFeatureEnabled('mon-copilot-draft-frontier-public', mailboxInfo) &&
            isFrontierPublicUser(mailboxInfo)) ||
        (isAccountFeatureEnabled('mon-copilot-draft-frontier-private-tap', mailboxInfo) &&
            isFrontierPrivateTAPUser(mailboxInfo))
    );
}
